// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart[data-v-12cc7c86]{display:flex;flex-direction:column;justify-content:center;align-items:center;border:1px solid #000;margin-top:10px}.chart[data-v-12cc7c86],.myChart[data-v-12cc7c86]{width:100%;height:400px}", ""]);
// Exports
module.exports = exports;
